import { Formik, Form, Field, ErrorMessage } from "formik";
import { useEffect, useState } from "react";

import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import httpApiCall from "../../service/api.service";
import * as Yup from "yup";
import toastr from "../elements/toast";
import "../login/login.scss";
import "../register/register.scss";
// import { setLoginData } from "../../service/shared.service";
import { connect, useSelector } from "react-redux";
import {
  companyLogo,
  eyeIconHide,
  eyeIconShow,
  question,
} from "../../assets/assets";
import {
  clearPartnerStorage,
  getMd5Hash,
  getStorageValue,
  Regex,
  setLoginData,
  setStorageKey,
  handleInputSpace
} from "../../service/shared.service";
import Spinner from "react-bootstrap/Spinner";
import InputMask from 'react-input-mask';


const Registercopy = () => {
  // const [forgot, setForgot] = useState(false);
  const toastrService = new toastr(true);
  const navigate = useNavigate();
  const answer = useSelector((state: any) => state.APIData.getSetting);
  const [mobileCode, setMobileCode] = useState('+1');
  // const [code, setCode] = useState([]);
  const [country, setCountry] = useState([]);
  const [countryId, setCountryId] = useState();
  const [countryIndex, setCountryIndex] = useState(0);
  const [currency, setCurrency] = useState([]);
  const [currencyId, setCurrencyId] = useState();
  const [message, setMessage] = useState([]);
  const [messageId, setMessageId] = useState();
  const [about, setabout] = useState();
  const [showReason, setShowReason] = useState();
  const [tooggle, setToogle] = useState(false);
  const [imageState, setImageSrc] = useState({
    imgSrc: eyeIconHide,
    showPwd: true,
  });
  const [sppiner, setSppiner] = useState(false);
  const [params] = useSearchParams();
  const [disableRefCode, setDisableRefCode] = useState(false);
  const [data, setdata] = useState({
    first_name: "",
    last_name: "",
    email: "",
    country: 0,
    phone: "",
    password: "",
    toggle:false,
    user_review: "",
    review: "",
    currency: "",
    countryCode: "",
    referral_code: ''
  });
  const [phoneRegex, setPhoneRegex] = useState<{
  phoneRegexLength: string;
  phone_length: string | number;
  min_phone_length: string | number;
}>({
  phoneRegexLength: "",
  phone_length: "",
  min_phone_length:""
});
  useEffect(() => {
    if (answer && answer && answer.country_data) {
      const countryData = answer.country_data.map((item: any) => ({
        value: item["country_id"],
        label: item["country_name"],
        currency: item["currency"],
        mobile_code: item["mobile_code"],
        phone_length: item["phone_length"]
        
      }));
      setStorageKey('country_data', countryData[0])
      setCountry(countryData);
      setCountryId(countryData[countryIndex]["value"]);
      setCurrencyId(countryData[countryIndex]['currency'][0]['currency_id']);
      if (answer.country_data && answer.country_data.length) {
        updateMasking(answer.country_data[0]['country_phone_format']);
        setPhoneRegex((data) => ({
      ...data,
      phone_length: answer.country_data[0]['phone_length'] || 12,
      min_phone_length: answer.country_data[0]['min_phone_length'] || 7
    }));
      }
    }

    if (answer && answer && answer.user_review_list) {
      const msg = answer.user_review_list.map((item: any) => ({
        value: item["message_id"],
        label: item["original_message"],
        text: item["text"],
      }));
      setMessage(msg);
    }
    const param: any = params.get('partner') || params.get('referral_code') || '';
    if (param) {
      data.referral_code = param;
      console.log(param);
      setdata((businessData) => ({
        ...businessData,
        referral_code: param
      }));
      setDisableRefCode(true);
    }
  }, [answer]);

  


  const validationSchema = Yup.object({
    first_name: Yup.string()
      .min(2, "First name is too Short")
      .max(40, "First name is too long")
      .required("Please enter first name").matches(Regex.name, 'Invalid first name'),
    last_name: Yup.string()
      .min(2, "Last name is too Short")
      .max(40, "Last name is too long")
      .required("Please enter last name").matches(Regex.name, 'Invalid last name'),
    email: Yup.string().max(50, "Email is too long")
      .email("Invalid email format")
      .required("Please enter valid email"),
    password: Yup.string()
    .required("Please Enter your password")
    .min(Regex.password_min_password_length, `New password must be at least ${Regex.password_min_password_length} characters long`)
    .matches(Regex.password_pattern,"Password must contain at least 8 characters, including 1 lowercase, 1 uppercase, 1 number, and 1 special character. Spaces are not allowed.")
    .max(Regex.password_max_password_length, `New password cannot be more than ${Regex.password_max_password_length} characters long`),
    // countryCode: Yup.string().required("Select Country Code"),
    country: Yup.string().required('Please select Country'),
    phone: Yup.string().required("Please Enter phone number").min(+phoneRegex.min_phone_length, `Phone number is not valid`).max(+phoneRegex.phone_length, `Phone number is not valid`),
    toggle: Yup.boolean().oneOf([true], 'Please accept terms & conditions.'),
    user_review: Yup.string(),
    currency: Yup.string().when([], (i, schema) => {
      return (currency?.length > 0 && (currencyId == 1 || currencyId == ''))
        ? schema.required("Please select currency")
        : schema.notRequired();
    }),
  });
  // console.log(currency,currencyId);
  
  const updateMasking = (format: "") => {
    const phoneRegexVar = format?.replace(/#/g, "9");
     setPhoneRegex((data) => ({
      ...data,
      phoneRegexLength: phoneRegexVar
    })); 
  }
  const currencyChange = (selectedIndex: any ,) => {
    setCountryIndex(() => selectedIndex);
    setCountryId(country[selectedIndex]["value"]);
    let a: [] = country[selectedIndex]["currency"];
    let b = country[selectedIndex]["mobile_code"];
    if (answer.country_data && answer.country_data.length) {
      updateMasking(answer.country_data[selectedIndex]['country_phone_format']);
    }
    setPhoneRegex((data) => ({
      ...data,
      phone_length: answer.country_data[selectedIndex]['phone_length'] || 12,
      min_phone_length: answer.country_data[selectedIndex]['min_phone_length'] || 7
    }));
    setStorageKey('country_data', country[selectedIndex])
    setMobileCode(b);
    // console.log(a, b, "vvvvvvvv");
    if (a.length > 1) {
      setCurrency(a);
    } else {
      setCurrency([]);
      a.map((item: any) => {
        setCurrencyId(item.currency_id);
        data.currency = item.currency_id;
        return item;
      });
    }
  };
  const goBack = () => {
    navigate("/login");
  };
  const selectReason = (e: any) => {
    let m = message[e];
    setMessageId(message[e]["value"]);
    setShowReason(m["text"]);
    setabout(e);
  };
  
  const handleSubmit = async (e: any) => {
    if ((e.first_name + " " + e.last_name).length > 100) {
      toastrService.showError('Please enter valid name'); 
      return;
    }
    const body = {
      partner_name: e.first_name + " " + e.last_name,
      country_id: countryId,
      currency_id: data.currency ? data.currency : currencyId,
      partner_mobile_country_code: mobileCode,
      partner_mobile: e.phone,
      partner_email: e.email.replace(/\s/g, "").toLowerCase(),
      partner_password: getMd5Hash(e.password),
      message_id: messageId,
      reason: e.reason,
      referral_code: e.referral_code || undefined,
      language_preffered: 'en'
    };
    setSppiner(true);
    await httpApiCall({ api: "register_partner", type: "post", body })
      .then((data) => {
        setSppiner(false);
        if (data && !data.is_error) {
          clearPartnerStorage();
          setLoginData(data, 1);
          navigate("/dashboard");
        } else {
          toastrService.showError(data.original_text || data.err);
        }
      })
      .catch((error) => {
        console.log("Error in Register:", error);
      });
  };
  const onPhoneChange = (event: any, setFieldValue: any) => {
    if (event.target.value) {
      event.target.value = event.target.value.replace(/[^0-9]+/g, "");
    }
    // console.log(event.target.value);
    setdata((businessData) => ({
      ...businessData,
      phone: event.target.value
    }));
    setFieldValue('phone', event.target.value);
  };
  const updateImage = () => {
    const src = !imageState.showPwd ? eyeIconHide : eyeIconShow;
    setImageSrc({
      imgSrc: src,
      showPwd: !imageState.showPwd,
    });
  };
  const checkBox = (event: any) => {
    // console.log(event.target.checked, "uigughuhuhuh");
  };

  return (
    <>
      {!getStorageValue("partnerToken") ? (
        <div className="login">
          <div className="login_flow container">
            <div className="login_flow_start_left">
              <div className="flow-left">
                <img
                  src={companyLogo}
                  alt="App Logo"
                  className="img-responsive img-logo"
                />
                <div className="start-journey">
                  <span>Start your journey with us</span>
                </div>
                <div className="back" onClick={goBack}>
                  <p>
                    <span>Already have an account?</span> Log In
                  </p>
                </div>
              </div>
            </div>
            <div className="login_flow_start_right">
              <div className="flow-right">
                <div className="signUp">
                  <p className="signUp_up">Sign Up</p>
                  <p className="signUp_portal">Get started for free</p>
                </div>
                <Formik
                  initialValues={data}
                  onSubmit={handleSubmit}
                  validationSchema={validationSchema}
                >
                  {({setFieldValue}) =>(
                    <Form autoComplete="off">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="" className="labels_input">
                            First Name <span className="asterik">*</span>
                          </label>
                          <Field
                            className="form-control"
                            type="text"
                            name="first_name"
                            placeholder="Enter first name"
                            autoComplete="off"
                            id="first_name"
                          />
                          <small className="text-danger m-2">
                            <ErrorMessage name="first_name" />
                          </small>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group ">
                          <label htmlFor="" className="labels_input">
                            Last Name<span className="asterik">*</span>
                          </label>
                          <Field
                            className="form-control"
                            type="text"
                            name="last_name"
                            placeholder="Enter last name"
                            autoComplete="off"
                            id="last_name"
                          />
                          <small className="text-danger m-2">
                            <ErrorMessage name="last_name" />
                          </small>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="form-group mb-3 select_country">
                          <label htmlFor="country" className="labels_input">
                            Select Country<span className="asterik">*</span>
                          </label>
                          <div className="arrowSelect">
                            
                          <Field
                            className="form-control"
                            as="select"
                            name="country"
                            onChange={(event:any) => {
                              currencyChange(event.target.value);
                              setFieldValue('country', event.target.value);
                            }}
                            id="country"
                          

                          >
                            <option disabled value={""}>
                              Select Country
                            </option>
                            {country?.map((e: any, i: any) => (
                              <option key={i} value={i}>
                                {e.label}
                              </option>
                            ))}
                          </Field>
                          </div>
                          <ErrorMessage name="country" component="small" className="text-danger m-2"  />

                        </div>
                      </div>
                      {currency?.length > 0 && (
                        <div className="col-md-6">
                          <div className="form-group select_country">
                            <label htmlFor="" className="labels_input">
                              Select Currency<span className="asterik">*</span>
                            </label>
                            <div className="arrowSelect">

                            <Field
                              className="form-control"
                              as="select"
                              name="currency"
                              value={data.currency}
                              onChange={(event:any) => {
                                setCurrencyId(event.target.value);
                                data.currency = event.target.value;
                                setFieldValue('currency', event.target.value);
                              }}
                              id="currency"
                            >
                              <option value={""}>Currency</option>
                              {currency?.map((e: any, i: any) => (
                                <option key={i} value={e.currency_id}>
                                  {e.currency_name}
                                </option>
                              ))}
                            </Field>
                            </div>
                            <small className="text-danger m-2">
                              <ErrorMessage name="currency" />
                            </small>
                          </div>
                        </div>
                      )}

                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="" className="labels_input">
                            Phone Number<span className="asterik">*</span>
                          </label>
                          <div className="mobilecode">
                            <p>{mobileCode}</p>
                            <Field
                              className="form-control"
                              name="phone"
                              id="phone"
                              >
                              {
                                (props: any) => <InputMask
                                  type="text"
                                  mask={phoneRegex.phoneRegexLength}
                                  maskChar={null}
                                  onChange={(event) => onPhoneChange(event, setFieldValue)}
                                  className="text-input form-control"
                                  id="phone_number"
                                  minLength={+phoneRegex.min_phone_length}
                                  maxLength={+phoneRegex.phone_length}

                                />
                              }
                            </Field>
                          </div>
                          <small className="text-danger m-2">
                            <ErrorMessage name="phone" />
                          </small>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="" className="labels_input">
                            E-mail<span className="asterik">*</span>
                          </label>
                          <Field
                            className="form-control"
                            type="email"
                            name="email"
                            placeholder="Enter email"
                            autoComplete="off"
                            id="register-email"
                          />
                          <small className="text-danger m-2">
                            <ErrorMessage name="email" />
                          </small>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="" className="labels_input">
                            Password<span className="asterik">*</span>
                          </label>
                          <div className="hide_show">
                            <Field
                              className="form-control"
                              type={imageState.showPwd ? "password" : "text"}
                              name="password"
                              placeholder="Enter password"
                              id="register-password"
                              onKeyDown={handleInputSpace}
                            />
                            <img
                              className="eye-icon IMG"
                              alt="icon"
                              onClick={() => {
                                updateImage();
                              }}
                              src={imageState.imgSrc}
                            />
                          </div>
                          <small className="text-danger">
                            <ErrorMessage name="password" />
                          </small>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="" className="labels_input">
                            How Did you Hear About us?
                          </label>
                          <Field
                            className="form-control"
                            as="select"
                            name="user_review"
                            onChange={(e: any) => selectReason(e.target.value)}
                            value={about}
                            id="user_review"
                          >
                            <option>Select</option>
                            {message.map((e: any, i: any) => (
                              <option key={i} value={i}>
                                {e.label}
                              </option>
                            ))}
                          </Field>
                          {/* <small className="text-danger m-2">
                        <ErrorMessage name="user_review" />
                      </small> */}
                        </div>
                      </div>
                      {showReason == 1 && (
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="" className="labels_input">
                              Please Specify
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="reason"
                              autoComplete="off"
                              id="reason"
                            />
                            <small className="text-danger m-2">
                              <ErrorMessage name="reason" />
                            </small>
                          </div>
                        </div>
                      )}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="" className="labels_input">
                            Referral code (optional)
                          </label>
                          <div className="hide_show">
                            <Field disabled={disableRefCode}
                              className="form-control"
                              type="text"
                              name="referral_code"
                              autoComplete="off"
                              id="referral_code"

                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group mb-0 checkbox_data">
                          <div className="hide_show d-flex align-items-center mt-3"  onClick={() => setToogle(!tooggle)}>
                            <span className="ms-2">
                              <label  htmlFor="toggleCheckbox" className="labels_input mb-0 cursor">
                              <Field type="checkbox" name="toggle"  id="toggleCheckbox" />
                               
                                <span className="toggle" id="toggleCheckbox"><span id="toggle_inner_span">I’ve read</span> & agree with all <Link target={"_blank"} className="termLink" to={"/Terms"}>Terms & Conditions. </Link> </span> 
                              </label>
                            </span>
                          </div>
                          <ErrorMessage name="toggle">
                              {(msg) => (
                                <small className="text-danger p-2">
                                  {msg}
                                </small>
                              )}
                            </ErrorMessage>
                        </div>
                      </div>

                      <div className="col-12 button_chase mt-3">
                        <button id="signUp" disabled={sppiner} className="loginBtn" type="submit">
                          Sign Up
                          {sppiner && (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          )}
                        </button>
                      </div>
                    </div>
                  </Form>
                  )}
                  
                </Formik>
              </div>
            </div>
          </div>
          <div className="bottom-login--wrap">
          <div className="login_end">
            <p>
              Visit <Link to="https://www.credee.com" target="_blank"> Credee.com </Link>
               to learn about benefits for being a partner with us
            </p>
          </div>
          <div className="login_help">
            <a href="https://www.credee.com/support" target="_blank">
              <span>
                <img src={question} alt="question" />
                Help & support
              </span>
            </a>
          </div>
          </div>
        </div>
      ) : (
        <Navigate to="/app/dashboard" replace={true} />
      )}
    </>
  );
};

// export default Registercopy;
const mapStateToProps = (state: any) => (
  // console.log(state),
  {
    settings: state.settingsData,
  }
);

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Registercopy);
